export const STALE_ASSESSMENT_GENERATION_MESSAGE = 'A newer TRL score exists for this Use and Domain. Generate from the most recent assessment.';
// Recency: assessmentDate (date-only) wins; same-day ties break on the full
// createdAt timestamp, so exactly one assessment per use/domain pair is the
// latest.
// See docs/iterations/AZ-384/AZ-384.DECISIONS.md (D11).
const getAssessmentRecency = (assessment) => [
    new Date(assessment.assessmentDate ?? assessment.createdAt).getTime(),
    new Date(assessment.createdAt).getTime(),
];
/**
 * Whether the assessment is the most recent one of its use/domain pair —
 * only that one may generate/regenerate TRL analyses (AZ-384 D11). A null
 * domain or use is its own bucket. Shared by the API guard and the web gate
 * so the disabled affordance and the 422 always agree.
 */
export const isLatestAssessmentForUseDomain = (params) => {
    const { assessment, assessments } = params;
    const [date, created] = getAssessmentRecency(assessment);
    return !assessments.some((other) => {
        if (other.id === assessment.id)
            return false;
        if (other.useId !== assessment.useId || other.domainId !== assessment.domainId)
            return false;
        const [otherDate, otherCreated] = getAssessmentRecency(other);
        return otherDate > date || (otherDate === date && otherCreated > created);
    });
};
